import { render, staticRenderFns } from "./highlightcorrectsummary.vue?vue&type=template&id=6476f390&scoped=true&"
import script from "./highlightcorrectsummary.vue?vue&type=script&lang=js&"
export * from "./highlightcorrectsummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6476f390",
  null
  
)

export default component.exports